import React from "react"
import Modal from "react-bootstrap/lib/Modal"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function BubbleModal(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { children, color = "blue" } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const mode = color === "red" ? "modal--bubble-red" : "modal--bubble-blue"

  // -------------------------------------

  return (
    <Modal {...props} className={`modal modal--bubble ${mode}`}>
      <div className={style.bubbleContainer}>
        <div className={`${style.bubble} ${style.bubbleTopLeft}`}></div>
        <div className={`${style.bubble} ${style.bubbleBottomRight}`}></div>
      </div>

      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}

// ----------------------------------------------------------------------------

export default BubbleModal
